import { render, staticRenderFns } from "./FrmLoginOwner.vue?vue&type=template&id=583ef954"
import script from "./FrmLoginOwner.vue?vue&type=script&lang=js"
export * from "./FrmLoginOwner.vue?vue&type=script&lang=js"
import style0 from "./FrmLoginOwner.vue?vue&type=style&index=0&id=583ef954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports